/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * FormSelect.tsx
 */

import HiloReactComponent from "../layout/HiloReactComponent";
import React from "react";
import {FormElementProps} from "./FormElement";
import {SelectField} from "../../model/form/SelectField";

export interface Props<D> extends FormElementProps<D> {
    field: SelectField<D>
}

export default class FormSelect<D> extends HiloReactComponent<Props<D>, {}> {
    /**
     * _selectItem
     * @private
     */
    private _selectionUpdated = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const {name} = this.props.field;

        let values = Array.from(e.target.selectedOptions, option => Number(option.value));
        let items = values.map(i => {
            return this.props.field.options[i].value;
        }) || [];

        this.props.onChange?.(name, items)
    };

    /**
     * render
     * @returns {any}
     */
    public render = () => {
        const {value, options, title, multiple} = this.props.field;

        return <div>
            <p>{title}</p>
            <select onChange={(e) => this._selectionUpdated(e)} size={Math.min(options.length, 10)} multiple={multiple}>
                {
                    options.map((item, index) => {
                        let isSelected = false;
                        if (value instanceof Array) {
                            isSelected = value.find(v => v === item.value) !== undefined;
                        } else {
                            isSelected = options.findIndex(option => option.value === value) >= 0;
                        }

                        return <option
                            selected={isSelected}
                            key={index}
                            value={index}>
                            {item.name}
                        </option>
                    })
                }
            </select>
        </div>;
    }
}